export default {"id":"1d0c12a2","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}